import { useState } from "react";
import { faqs } from "@/mocks/fengchiData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-14">
          <div className="lg:sticky lg:top-24 self-start">
            <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium">
              <i className="ri-questionnaire-line" />
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              看完还有疑问？先看这里
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              关于「好看吗」「值不值得看」「评分怎么来的」这些高频问题，我们都整理在了下面。
              点击每一题即可展开查看完整回答。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-primary-200 bg-primary-50 p-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl" />
              </span>
              <p className="text-sm text-foreground-700">
                口碑数据会持续更新，建议收藏本页随时回来对比。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                      aria-expanded={open}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {faq.q}
                      </span>
                      <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-4 md:px-5 pb-5 -mt-1 animate-fadeUp">
                      <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                        {faq.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}